import React from "react";
import { FlexColumn, FlexRow, Text } from "../../../styles/Global";
import * as Global from "../../../styles/Global";
import StatBlock from "../StatBlock";
import "../../../App.scss";

const ScoremagicStats = ({
  data,
  viewType,
  showDPR,
  isPractice,
  formatType,
  value,
}) => {
  console.log("scoremagicStats data: ", data);
  console.log("scoremagicStats viewType: ", viewType);
  
  return (
    <>
      {value > 1 && (
        <FlexRow
          style={{ width: "100%", marginTop: 10 }}
          align="center"
          justify="center"
        >
          <Text
            style={{ fontStyle: "italic", textAlign: "center" }}
            size=".7em"
          >
            {formatType === "all"
              ? "Sandbag %"
              : formatType === "bracket"
              ? "Bracket stat"
              : "Round Robin stat"}{" "}
            tracking began in December 2023
          </Text>
        </FlexRow>
      )}
      <FlexRow
        style={{
          paddingBottom: 10,
          borderRadius: 20,
        }}
        justify="center"
        align="center"
      >
        <StatBlock
          topText={data.totalRounds.toLocaleString()}
          bottomText="Rounds"
          blur={viewType < 2}
        />
        <StatBlock topText={data.ppr} bottomText="PPR" blur={viewType < 2} />
        {data.dpr && showDPR ? (
          <StatBlock topText={data.dpr} bottomText="DPR" blur={viewType < 2} />
        ) : null}
        <StatBlock
          topText={data.oppr}
          bottomText="Opp PPR"
          blur={viewType < 2}
        />
      </FlexRow>
      <FlexRow style={{ marginTop: 10 }} justify="center">
        <StatBlock
          topText={
            <FlexColumn align="center">
              {data.inFourPercent !== undefined && data.inFourPercent !== null && (
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.inFourPercent}%
                </Text>
              )}
              <Text size="13px">{data.inFourTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="4 In"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              {data.inPercent !== undefined && data.inPercent !== null && (
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.inPercent}%
                </Text>
              )}
              <Text size="13px">{data.inTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="In"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              {data.onPercent !== undefined && data.onPercent !== null && (
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.onPercent}%
                </Text>
              )}
              <Text size="13px">{data.onTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="On"
          blur={viewType < 2}
        />
        <StatBlock
          topText={
            <FlexColumn align="center">
              {data.offPercent !== undefined && data.offPercent !== null && (
                <Text size="20px" style={{ fontWeight: "700" }}>
                  {data.offPercent}%
                </Text>
              )}
              <Text size="13px">{data.offTotal.toLocaleString()}</Text>
            </FlexColumn>
          }
          bottomText="Off"
          blur={viewType < 2}
        />
      </FlexRow>
      {!isPractice &&
        data.hasOwnProperty("roundWinTotal") &&
        data.hasOwnProperty("roundLossTotal") &&
        data.hasOwnProperty("roundTieTotal") && (
          <FlexRow style={{ marginTop: 10 }} justify="center">
            <StatBlock
              topText={
                <FlexColumn align="center">
                  {data.roundWinPercent !== undefined && data.roundWinPercent !== null && (
                    <Text size="20px" style={{ fontWeight: "700" }}>
                      {data.roundWinPercent}%
                    </Text>
                  )}
                  <Text size="13px">{data.roundWinTotal.toLocaleString()}</Text>
                </FlexColumn>
              }
              bottomText="Round Win"
              blur={viewType < 2}
            />
            <StatBlock
              topText={
                <FlexColumn align="center">
                  {data.roundLossPercent !== undefined && data.roundLossPercent !== null && (
                    <Text size="20px" style={{ fontWeight: "700" }}>
                      {data.roundLossPercent}%
                    </Text>
                  )}
                  <Text size="13px">
                    {data.roundLossTotal.toLocaleString()}
                  </Text>
                </FlexColumn>
              }
              bottomText="Round Loss"
              blur={viewType < 2}
            />
            <StatBlock
              topText={
                <FlexColumn align="center">
                  {data.roundTiePercent !== undefined && data.roundTiePercent !== null && (
                    <Text size="20px" style={{ fontWeight: "700" }}>
                      {data.roundTiePercent}%
                    </Text>
                  )}
                  <Text size="13px">{data.roundTieTotal.toLocaleString()}</Text>
                </FlexColumn>
              }
              bottomText="Round Tie"
              blur={viewType < 2}
            />
            {formatType === "all" && (
              <StatBlock
                topText={
                  <FlexColumn align="center">
                    {data.matchTypeDiffPercent !== undefined && data.matchTypeDiffPercent !== null && (
                      <Text size="20px" style={{ fontWeight: "700" }}>
                        {data.matchTypeDiffPercent}%
                      </Text>
                    )}
                    <Text size="13px">
                      {data.matchTypeDiff.toLocaleString()}
                    </Text>
                  </FlexColumn>
                }
                bottomText="SB%"
                blur={viewType < 2}
              />
            )}
          </FlexRow>
        )}
    </>
  );
};

export default ScoremagicStats;
